export default "__VITE_ASSET__402fbca1__"